import React from 'react';
import { Sprout, Wind, CheckCircle, ArrowRight } from 'lucide-react';

const RootsWings = () => {
  return (
    <section className="bg-gray-50 pt-12">
      <div id="roots-wings" className="container max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        {/* Header */}
        <div className="flex flex-col items-center justify-center mb-20">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-4">
            Roots & Wings Philosophy
          </h2>
          <p className="text-gray-600 text-center max-w-2xl">
            Our approach balances fundamental stability with growth potential for long-term wealth creation.
          </p>
        </div>

        {/* Main content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          {/* Roots Card */}
          <div className="bg-white backdrop-blur-md border-l-4 border-[#113262] rounded-r-lg shadow-xl overflow-hidden">
            <div className="p-10">
              {/* Card Header */}
              <div className="flex items-center mb-10">
                <div className="w-14 h-14 bg-[#113262] rounded-lg flex items-center justify-center shadow-lg mr-5">
                  <Sprout className="w-7 h-7 text-[#F49611]" />
                </div>
                <h3 className="text-xl md:text-2xl lg:text-3xl font-bold text-[#113262] mr-5">Roots</h3>
              </div>

              {/* Divider */}
              <div className="w-full h-px bg-gradient-to-r from-[#143970]/20 via-[#143970] to-[#143970]/20 mb-10"></div>

              {/* Card content */}
              <p className="text-gray-700 text-lg mb-10">
                Preserving wealth through companies with strong fundamentals and stability.
              </p>

              <div className="space-y-6">
                {['Low debt balance sheets', 'High Return on Equity', 'Strong promoter ownership'].map((item, i) => (
                  <div key={i} className="flex items-start">
                    <CheckCircle className="w-6 h-6 text-[#1C52A0] mr-4 flex-shrink-0" />
                    <p className="text-gray-600 text-lg">{item}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Wings Card */}
          <div className="bg-white backdrop-blur-md border-r-4 border-[#113262] rounded-l-lg shadow-xl overflow-hidden">
            <div className="p-10">
              {/* Card Header */}
              <div className="flex items-center justify-end mb-10">
                <h3 className="text-xl md:text-2xl lg:text-3xl font-bold text-[#113262] mr-5">Wings</h3>
                <div className="w-14 h-14 bg-[#113262] rounded-lg flex items-center justify-center shadow-lg">
                  <Wind className="w-7 h-7 text-[#F49611]" />
                </div>
              </div>

              {/* Divider */}
              <div className="w-full h-px bg-gradient-to-r from-[#143970]/20 via-[#143970] to-[#143970]/20 mb-10"></div>

              {/* Card content */}
              <p className="text-gray-700 text-lg mb-10">
                Accelerating growth through companies with expanding market presence.
              </p>

              <div className="space-y-6">
                {['Growing sales & earnings', 'Steady cash flow growth', 'Resilient market positioning'].map((item, i) => (
                  <div key={i} className="flex items-start">
                    <CheckCircle className="w-6 h-6 text-[#1C52A0] mr-4 flex-shrink-0" />
                    <p className="text-gray-600 text-lg">{item}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="mt-10 flex justify-end">
          <a href="/roots-wings" className="flex items-center text-[#1C52A0] hover:text-[#0A1E3A] transition-colors duration-300">
            <span className="font-semibold">Learn More</span>
            <ArrowRight className="ml-2 h-4 w-4" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default RootsWings;